import { FC } from 'react';

import moment from 'moment';

import {
  Wrapper,
  Styledlabel,
  MainLabel,
  SubLabel,
  LabelContainer,
} from './styled';

type PropTypes = {
  value: string;
  label: string;
  isOneWay?: boolean;
  rightBorder?: boolean;
  onClick?(): void;
};

const SelectedComp: FC<PropTypes> = ({
  value,
  label,
  isOneWay,
  rightBorder,
  onClick,
}) => {
  value = value || '';
  const newvalue = value.split('.');

  const months = moment.monthsShort();
  const selectedDay = newvalue[0];
  const selectedMonth = months[+newvalue[1] - 1];
  const selectedYear = newvalue[2]?.trimEnd().slice(-2);

  return (
    <Wrapper onClick={onClick} isOneWay={isOneWay} rightBorder={rightBorder}>
      <MainLabel>{label}</MainLabel>
      <LabelContainer>
        <Styledlabel>{selectedDay}</Styledlabel>
        <SubLabel>
          {selectedMonth} {selectedYear}
        </SubLabel>
      </LabelContainer>
    </Wrapper>
  );
};

export default SelectedComp;
